import { CustomButton, CustomTextInput } from "@Modules/core/components";
import CustomFormControl from "@Modules/core/components/form/CustomFormControl";
import { IRulesPerPANFormMeta } from '@Modules/cardManagementSystem/smart/containers/tableHandlers/scriptProcessing/rules/perPAN/RulesPerPANMeta';
import { ChakraComponents as CC } from "@Modules/core/lib/chakra";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { FaSave } from "react-icons/fa";
import displayCustomInputs from '@Shared/utils/displayCustomInputs';

type Props = {
  onSubmit: any,
  meta: IRulesPerPANFormMeta,
  isLoading?: boolean,
  isSubmitting?: boolean,
} 

const RulesPerPANFormUI = ({onSubmit, isLoading, isSubmitting, meta}: Props) => {

    const {
        register,
        handleSubmit,
        formState: { errors },
        // reset,
      } = useForm({ resolver: yupResolver(meta.schema),});
    
  return (
    <>
        <form onSubmit={handleSubmit(onSubmit)}>        
        <CC.Box my="4" mb='8'>
          <CC.SimpleGrid columns={{ base:1, md:2 }} gridRowGap={4} columnGap={10} my={4}>
            {displayCustomInputs(
              meta,
              register,
              errors,
              isLoading,
            )}
          </CC.SimpleGrid>
          

          <CC.Flex justify={'flex-end'}>
            <CustomButton isLoading={isSubmitting} type="submit" >
              <span>Afficher</span>
            </CustomButton>
          </CC.Flex>
        </CC.Box>
      </form>
    </>    
  )
}

export default RulesPerPANFormUI;